module.exports = __webpack_public_path__ + "img/扶梯3.2e63a560.png";